import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}
export function Pagination({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange
}: PaginationProps) {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 7;
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 4) {
        for (let i = 1; i <= 5; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    return pages;
  };
  return <div className="flex items-center justify-between bg-white px-6 py-4 border border-gray-200 rounded-lg shadow-sm" data-id="element-303">
      <div className="flex flex-1 justify-between sm:hidden" data-id="element-304">
        <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="relative inline-flex items-center rounded-lg border-2 border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200" data-id="element-305">
          Previous
        </button>
        <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="relative ml-3 inline-flex items-center rounded-lg border-2 border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200" data-id="element-306">
          Next
        </button>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between" data-id="element-307">
        <div data-id="element-308">
          <p className="text-sm text-gray-600 font-medium" data-id="element-309">
            Showing{' '}
            <span className="font-semibold text-gray-900" data-id="element-310">{startItem}</span> to{' '}
            <span className="font-semibold text-gray-900" data-id="element-311">{endItem}</span> of{' '}
            <span className="font-semibold text-gray-900" data-id="element-312">{totalItems}</span>{' '}
            results
          </p>
        </div>
        <div data-id="element-313">
          <nav className="isolate inline-flex gap-2" aria-label="Pagination" data-id="element-314">
            <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="relative inline-flex items-center justify-center w-10 h-10 rounded-lg text-gray-600 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 border-2 border-gray-200 hover:border-gray-300" data-id="element-315">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-316" />
            </button>
            {getPageNumbers().map((page, index) => page === '...' ? <span key={`ellipsis-${index}`} className="relative inline-flex items-center justify-center w-10 h-10 text-sm font-semibold text-gray-500" data-id="element-317">
                  ...
                </span> : <button key={page} onClick={() => onPageChange(page as number)} className={`relative inline-flex items-center justify-center w-10 h-10 text-sm font-semibold rounded-lg transition-all duration-200 border-2 ${currentPage === page ? 'bg-blue-600 text-white border-blue-600 shadow-sm' : 'text-gray-700 border-gray-200 hover:bg-gray-50 hover:border-gray-300'}`} data-id="element-318">
                  {page}
                </button>)}
            <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="relative inline-flex items-center justify-center w-10 h-10 rounded-lg text-gray-600 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 border-2 border-gray-200 hover:border-gray-300" data-id="element-319">
              <ChevronRightIcon className="h-5 w-5" data-id="element-320" />
            </button>
          </nav>
        </div>
      </div>
    </div>;
}